module.exports = __webpack_public_path__ + "static/media/DiscoveMe.2ed466b0.png";